// extracted by mini-css-extract-plugin
module.exports = {"page":"efdelta-recall-and-replacement_page__sDw7O"};